import React, {
  useContext,
  useRef,
  useState,
  useEffect,
  Fragment,
  useMemo,
  useCallback,
} from "react";
import { Helmet } from "react-helmet";
import { useLocation, useParams, Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import Avatar from "../VibehutUI/Avatar";
import Button from "../VibehutUI/Button";
import Loader from "../VibehutUI/Loader";
import TalkingUsersModal from "../VibehutUI/TalkingUsersModal";
import UserCard from "../VibehutUI/UserCard";
import { StoreContext } from "../Context/StoreContext";
import { getScreenRoom } from "../actions/roomAction";
import { getUserData } from "../services/userService";
import {
  getModeratorsByRoomId,
  getApps,
  getAppBySlug,
  getReviewdPromptId,
  getPromptById,
  getRoomSubscriberApprovalStatus,
  checkUserDiamondedToPost,
  checkDesoHolderToPublicKey,
} from "../services/rooomService";
import axios, { baseURL, domain, videoAppUrl } from "../utils/axios";
import * as io from "socket.io-client";
import EventCard from "../VibehutUI/Card/EventCard";
import Resources from "../components/Resources";
import CreateEvent from "../components/events/CreateEvent";
import Lock from "../VibehutUI/Icons/Lock";
import { getRoomEvents } from "../actions/eventActions";
import RoomModal from "../VibehutUI/RoomModal";
import AllEventModel from "../VibehutUI/AllEventModel";
import Subscriptions from "../VibehutUI/Icons/Subscriptions";
import moment from "moment-timezone";
import CopyButton from "../VibehutUI/CopyButton";
import EmbedRoomModal from "../VibehutUI/EmbedRoomModel";
import Code from "../VibehutUI/Icons/Code";
import PopOver from "../VibehutUI/Popover";
import NFTRoomCard from "../components/NFTRoomCard";
import Linkify from "react-linkify";
import ActivityRoom from "../VibehutUI/WhatsHappening/ActivityRoom";
import SubscriptionModal from "../VibehutUI/SubscriptionModal";
import NotificationUpdate from "../VibehutUI/Notification/NotificationUpdate";
import globals from "../globals";
import {
  calcPlanIconColor,
  checkMyRoomSubscription,
  getDiamondIconsFromDiamondLevel,
  getUserRole,
  isMobile,
  userServiceRoleMap,
} from "../utils/utils";
import { useHistory } from "react-router-dom";
import HidEye from "../VibehutUI/Icons/HidEye";
import EventCardSkeleton from "../VibehutUI/Skeletons/EventCardSkeleton";
import EditRoom from "../components/rooms/EditRoom";
import Edit from "../VibehutUI/Icons/Edit";
import { getMySubscriptions } from "../actions/subscriptions";
import { useStripeSuccessCallback } from "../hooks/useStripeCallback";
import {
  profileRoute,
  singleClaimedRoomRoutes,
  singleRoomRoutes,
} from "../routes";
import Check from "../VibehutUI/Icons/Check";
import { Menu, Transition } from "@headlessui/react";
import OptionButton from "../VibehutUI/Icons/OptionButton";
import Trash from "../VibehutUI/Icons/Trash";
import DeleteRoom from "../components/rooms/DeleteRoom";
import { useWindowSize } from "../hooks/useWindowSize";
import * as actionTypes from "../constants";
import SubscriberApproval from "../VibehutUI/Icons/SubscriberApproval";
import SubscriberApproved from "../VibehutUI/Icons/SubscriberApproved";
import { checkEventSubscription } from "../services/eventSubscriptionService";
import { openEventSubscriptionModal } from "../actions/eventModalActions";
import Empty from "../VibehutUI/Empty";
import NoConnections from "../VibehutUI/Icons/NoConnections";
import WeeklyPassCard from "../components/rooms/weeklyPass/WeeklyPassCard";
import AppCard from "../VibehutUI/Card/AppCard";
import LimitedTextarea from "../VibehutUI/LimitedTextarea";
import { showToast } from "../actions/toastActions";
import SelfOrganizedEvents from "../components/events/SelfOrganizedEvents";
import RoomTestimonials from "../components/testimonials/RoomTestimonial";
import SpecificChat from "../components/chat/SpecificChat";
import RoomSkeleton from "../VibehutUI/Skeletons/RoomSkeleton";
import useIsPWA from "../hooks/usePWA";
import { showLoginModal } from "../actions/uiModalActions";
import Polygon from "../VibehutUI/Icons/Polygon";
import PaidBadgeRaw from "../VibehutUI/Icons/PaidBadgeRaw";
import DoubleStar from "../VibehutUI/Icons/DoubleStar";
import CreateEventByAIModal from "../VibehutUI/CreateEventByAIModal";
import { useDesoProtocol } from "../hooks/useDesoProtocol";
import * as userFeedService from "../services/userPostsService";
import ResourceSkeleton from "../VibehutUI/Skeletons/ResourceSkeleton";
import InstantJoinCallButton from "../components/rooms/InstantJoinCallButton";
import QrCodeModal from "../VibehutUI/Video/VideoControls/QrCodeModal";
import { QRIcon } from "../videoChat/icons/QRCode";

function SingleRoomPage() {
  useStripeSuccessCallback(() => {
    globals.closePaymentStatusModal();
    setTimeout(() => {
      globals.handleSubscription();
    }, 1000);
  });

  const {
    eventId,
    roomId: roomIdFromRoute,
    slug,
    appSlug,
    promptId,
  } = useParams();
  const socketRef = useRef();
  const isPWA = useIsPWA();
  const history = useHistory();
  const location = useLocation();
  const { state, dispatch } = useContext(StoreContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [eventData, setEventData] = useState(null);
  const [calls, setCalls] = useState([]);
  const [talkingUsersCount, setTalkingUsersCount] = useState(0);
  const [isOpenRoomPass, setOpenRoomPass] = useState(false);
  const [isShiftKeyDown, setIsShiftKeyDown] = useState(false);
  const {
    auth: { user },
    subscription: { mySubscriptions },
    event: {
      events,
      isFetching,
      isMoreRoomEvents,
      isMoreRoomEventsFetching,
      roomEventsOffset,
    },
    room: {
      liveRoom: { liveRoom: room },
      totalSubscribedRooms,
      isFetchingScreenRoom,
    },
    setting: { diamondExchangeLists },
    role,
    accessPass,
  } = state;
  const { width } = useWindowSize();
  const desoProtocol = useDesoProtocol();
  // eslint-disable-next-line no-console
  const [showTooltip, setShowTooltip] = useState(false);
  const [tagsLocation, setTagsLocation] = useState(undefined);
  const [showUserTooltip, setShowUserTooltip] = useState(false);
  const [username, setUsername] = useState("");
  const [liveUsersCount, setLiveUsersCount] = useState(0);
  const [lobbyUsers, setLobbyUsers] = useState([]);
  const [isCreateEventOpen, setCreateEventOpen] = useState(false);
  const [event, setEvent] = useState(null);
  const [isAllEventModelOpen, setIsAllEventModelOpen] = useState(false);
  const [isEmbedOpen, setIsEmbedOpen] = useState(false);
  const [isSubscriptionOpen, setIsSubscriptionOpen] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [roomId, setRoomId] = useState(null);
  const [isFetchingTagsLocation, setIsFetchingTagsLocation] = useState(false);
  const isAppPage = useLocation().pathname.includes("/apps");
  const isPromptResponsePage = useLocation().pathname.includes("/response");

  const [apps, setApps] = useState([]);
  const [app, setApp] = useState(null);
  const sectionRef = useRef(null);
  const [isEventModalOpen, setIsEventModalOpen] = useState(false);
  const [writingDescription, setWritingDescription] = useState("");
  const [amiResponse, setAmiResponse] = useState("");
  const [isReviewing, setIsReviewing] = useState(false);
  const [isQRModalOpen, setIsQRModalOpen] = useState(false);
  const [isDiamondSending, setIsDiamondSending] = useState(false);
  const [promptIdVal, setPromptIdVal] = useState(null);
  const [roomSubscriberApprovalStatus, setRoomSubscriberApprovalStatus] =
    useState("");
  const [roomSubscriberApprovalDate, setRoomSubscriberApprovalDate] =
    useState("");
  const [desoPost, setDesoPost] = useState(null);
  const [isDesoPostApproved, setIsDesoPostApproved] = useState(false);
  const [isDesoHodlerApproved, setIsDesoHodlerApproved] = useState(false);

  const [isDesoPostDetailFetching, setIsDesoPostDetailFetching] =
    useState(false);
  const [isDesoHodlerDetailFetching, setIsDesoHodlerDetailFetching] =
    useState(false);
  const [showFullText, setShowFullText] = useState(false);
  let promptInterval;

  useEffect(() => {
    if (room?._id) {
      room["name"] = room?.name.replace(" with $(_user)", "");
      setRoomId(room?._id);
    }
  }, [room]);

  useEffect(() => {
    if (user?.token) {
      getMySubscriptions(user.token, dispatch);
    }
  }, [user?.token, dispatch]);

  useEffect(() => {
    const isFromCard = new URLSearchParams(location.search).get("fromCard");
    if (isFromCard === "true" && sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.search]);
  const getRoomSubscriberApprovalStatusFun = useCallback(async () => {
    getRoomSubscriberApprovalStatus(roomId, user?.token)
      .then((res) => {
        if (res.data?.status) {
          setRoomSubscriberApprovalStatus(res.data.status);
          setRoomSubscriberApprovalDate(res.data.createdAt);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [roomId, user?.token]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Shift") {
        setIsShiftKeyDown(true);
      }
    };

    const handleKeyUp = (event) => {
      if (event.key === "Shift") {
        setIsShiftKeyDown(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  const updateSocketData = ({ queue_room }) => {
    setUsers(queue_room.users);
    setLiveUsersCount(queue_room.liveUsersCount);

    if (queue_room.lobby_users) {
      setLobbyUsers(queue_room.lobby_users);
    }
    if (queue_room.talkingUsersCount) {
      setTalkingUsersCount(queue_room.talkingUsersCount);
    }
    setCalls(Object.values(queue_room.calls || {}));
  };

  useEffect(() => {
    if (roomId) {
      getRoomEvents(user?.token, dispatch, roomId, false, 0);
      getRoomSubscriberApprovalStatusFun();
    }
  }, [dispatch, getRoomSubscriberApprovalStatusFun, roomId, user?.token]);

  const getRoom = async () => {
    try {
      dispatch({
        type: actionTypes.GET_SCREEN_ROOM_REQUEST,
      });
      if (slug) {
        await getScreenRoom(user?.token, dispatch, slug);
        if (appSlug) {
          await getAppBySlug(appSlug).then((res) => {
            setApp(res.data);
            setPromptPage();
          });
        } else if (isAppPage) {
          await getApps(res.data.roomId).then((res) => {
            setApps(res.data);
          });
        }
      } else {
        await getScreenRoom(
          user?.token,
          dispatch,
          roomIdFromRoute || room?._id,
        );
        setRoomId(roomIdFromRoute || room?._id);
        if (appSlug) {
          await getAppBySlug(appSlug).then((res) => {
            setApp(res.data);
            setPromptPage();
          });
        } else if (isAppPage) {
          await getApps(roomIdFromRoute || room?._id).then((res) => {
            setApps(res.data);
          });
        }
      }
    } catch (error) {
      setRoomId(null);
    }
  };

  useEffect(() => {
    const mySubscription = checkMyRoomSubscription(mySubscriptions, room?._id);
    setSubscriptionData(mySubscription);
  }, [mySubscriptions, room]);

  const checkDesoPostRoomAccessable = async (roomId) => {
    try {
      const sender = (await checkUserDiamondedToPost(roomId, user?.token)).data;
      return sender;
    } catch (error) {}
  };

  const checkDesoHodlerRoomAccessible = async (roomId) => {
    try {
      const token = user?.token;
      const sender = (await checkDesoHolderToPublicKey(roomId, token)).data;
      return sender;
    } catch (error) {}
  };

  useEffect(() => {
    if (room?.desoPostRoom?.postHashHex) {
      userFeedService
        .getSingleDesoPost(
          user?.bitclout_data?.bitclout_publickey || "",
          room?.desoPostRoom?.postHashHex,
        )
        .then((post) => {
          setDesoPost(post);
        });

      setIsDesoPostDetailFetching(true);
      checkDesoPostRoomAccessable(room?._id)
        .then((isRoomAccessible) => {
          setIsDesoPostApproved(isRoomAccessible);
        })
        .finally(() => {
          setIsDesoPostDetailFetching(false);
        });
    }
  }, [mySubscriptions, room]);

  useEffect(() => {
    if (room?.isCCRoom || room?.isDAORoom) {
      setIsDesoHodlerDetailFetching(true);
      checkDesoHodlerRoomAccessible(room?._id)
        .then((isRoomAccessible) => {
          setIsDesoHodlerApproved(isRoomAccessible);
        })
        .finally(() => {
          setIsDesoHodlerDetailFetching(false);
        });
    }
  }, [mySubscriptions, room]);

  const eventCallBack = async () => {
    await getRoomEvents(user?.token, dispatch, roomId, false, 0);
  };

  const handleOpenCreateEventWithAI = (eventData) => {
    setEventData(eventData);
    setCreateEventOpen(true);
  };

  React.useEffect(() => {
    if (roomId) {
      socketRef.current = io.connect(`${baseURL}/room`);
      socketRef.current.on("connect", () => {
        socketRef.current.emit(
          "join-room",
          {
            roomId,
          },
          updateSocketData,
        );
      });
      socketRef.current.on("update_call", updateSocketData);
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = undefined;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomId]);

  React.useEffect(() => {
    if (eventId) {
      axios.get(`/events/event/${eventId}`).then((res) => {
        if (res.status === 200) {
          setEvent(res.data.data.event);
        } else {
          console.log(res);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId]);

  React.useEffect(() => {
    if (roomId) {
      setIsFetchingTagsLocation(true);
      axios
        .get(`rooms/get-room-resources-tags-location/${roomId}`, {
          headers: user?.token
            ? {
                Authorization: `Bearer ${user.token}`,
                "Content-Type": "application/json",
              }
            : {},
        })
        .then((res) => {
          if (res.status === 200) {
            if (res.data && res.data.data && res.data.data.length > 0) {
              const resourcesTagsLocationData = res.data.data[0];
              if (
                resourcesTagsLocationData.tags &&
                resourcesTagsLocationData.tags.length > 0
              ) {
                resourcesTagsLocationData.tags = [
                  "all",
                  ...resourcesTagsLocationData.tags,
                ];
              }
              setTagsLocation(resourcesTagsLocationData);
            }
          } else {
            console.log(res);
          }
        })
        .catch((error) => {
          console.log("error::", error);
        })
        .finally(() => {
          setIsFetchingTagsLocation(false);
        });
    }
  }, [roomId, user?.token]);

  React.useEffect(() => {
    getRoom();
    return () => {
      dispatch({
        type: actionTypes.CLEAR_SCREEN_ROOM_SUCCESS,
      });
      dispatch({
        type: actionTypes.RESET_ROOM_EVENTS_SUCCESS,
      });
      // dispatch({
      //   type: actionTypes.CLEAR_SCREEN_ROOM_SLUG_SUCCESS,
      // });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomIdFromRoute, slug]);

  // React.useEffect(() => {
  //   if (eventId && roomSlug) {
  //     history.replace(`/${roomSlug}/events/${eventId}`);
  //   } else if (roomSlug) {
  //     history.replace(`/${roomSlug}`);
  //   }
  // }, [roomSlug, eventId]);

  const { roomHasSubscription, isUserSubscribed, isNextRenewal } =
    React.useMemo(() => {
      const roomHasSubscription =
        room?.owner?._id !== undefined &&
        user?._id !== room?.owner?._id &&
        room?.hasSubscription;

      return {
        roomHasSubscription:
          room?.owner?._id !== undefined &&
          user?._id !== room?.owner?._id &&
          room?.hasSubscription,
        isUserSubscribed:
          roomHasSubscription &&
          ((subscriptionData?.nextRenewal &&
            new Date(subscriptionData?.nextRenewal).getTime() >
              new Date().getTime()) ||
            subscriptionData?.isOneTime),
        isNextRenewal: roomHasSubscription && subscriptionData?.isNextRenewal,
      };
    }, [
      room?.hasSubscription,
      room?.owner?._id,
      subscriptionData?.isNextRenewal,
      subscriptionData?.nextRenewal,
      user?._id,
      subscriptionData?.isOneTime,
    ]);

  const isModerator = () => {
    if (room.owner?._id?.toString() === user?._id.toString()) return true;
    if (room.moderators) {
      for (let i = 0; i < room.moderators.length; i++) {
        if (room.moderators[i].toString() === user?._id.toString()) return true;
      }
    }
    return false;
  };

  const isAccessPassHolder = useMemo(() => {
    if (!accessPass.data || !room?._id) return false;
    const pass = accessPass.data?.find(
      (pass) => pass.kind === "room" && pass.refItem === room._id,
    );

    return !!pass;
  }, [accessPass.data, room?._id]);

  const handleDescriptionChange = (text) => {
    setWritingDescription(text);
  };

  const checkLiveEventAndIfUserIsSubscribed = async () => {
    const currentDate = new Date();
    let liveEvent = null;
    events.forEach((event) => {
      const eventStart = new Date(event.startDate);
      const eventEnd = new Date(event.endDate);
      if (eventStart < currentDate && eventEnd > currentDate) {
        liveEvent = event;
      }
    });

    if (
      liveEvent &&
      liveEvent.isPaidEvent &&
      !isModerator() &&
      !isAccessPassHolder
    ) {
      const checkSubscription = await checkEventSubscription(
        user.token,
        liveEvent._id,
      );
      if (checkSubscription?.data?.checkSubscription) {
        return true;
      }
      openEventSubscriptionModal(
        dispatch,
        liveEvent,
        `There is a live event going on in this room. Please subscribe to join the event. Otherwise you can wait join the room after the event ends.`,
        "event",
      );
      return false;
    }
    return true;
  };

  const goToCallPage = (joinInstantCall) => {
    if (joinInstantCall && room?.isQuickJoin) {
      const path = room?.slug
        ? singleClaimedRoomRoutes.path.replace(":slug", room.slug)
        : singleRoomRoutes.path.replace(":roomId", room._id);
      if (!isPWA) {
        window.open(`${videoAppUrl}${path}/instant`);
      } else {
        window.location.href = `${videoAppUrl}${path}/instant`;
      }
    } else {
      if (!isPWA) {
        window.open(`${videoAppUrl}/call?roomKey=${roomId}`);
      } else {
        window.location.href = `${videoAppUrl}/call?roomKey=${roomId}`;
      }
    }
  };
  const resetWriting = () => {
    if (isPromptResponsePage) {
      resetCurrentPath();
    }
    setWritingDescription("");
    setAmiResponse("");
    setPromptIdVal(null);
  };

  const setPromptPage = () => {
    if (isPromptResponsePage) {
      getPromptById(promptId, user?.token).then(async (promptRes) => {
        if (promptRes && promptRes.data && promptRes.data.messages.length > 2) {
          setAmiResponse(promptRes.data.messages[2].content);
          setWritingDescription(promptRes.data.messages[1].content);
        }
      });
    }
  };
  const reviewWrting = () => {
    if (writingDescription.trim().length === 0) {
      showToast(dispatch, "error", "Message can't be blank ", 5000);
      return;
    }
    if (!user) {
      return showLoginModal(dispatch);
    }
    if (isPromptResponsePage) {
      resetCurrentPath();
    }
    const messages = [];
    messages.push({ role: "system", content: app.prompt?.systemPrompt });
    messages.push({ role: "user", content: writingDescription });
    setIsReviewing(true);
    setAmiResponse("Ok, thanks! Taking a look...");
    getReviewdPromptId(messages, user?.token, app._id, roomId)
      .then(async (res) => {
        if (res && res.data) {
          promptInterval = setInterval(() => {
            getPromptById(res.data, user?.token)
              .then(async (promptRes) => {
                if (
                  promptRes &&
                  promptRes.data &&
                  promptRes.data.messages.length > 2
                ) {
                  setAmiResponse(promptRes.data.messages[2].content);
                  setPromptIdVal(res.data);
                  setIsReviewing(false);
                  clearInterval(promptInterval);
                }
              })
              .catch(() => {
                setIsReviewing(false);
                clearInterval(promptInterval);
              });
          }, 5000);
        }
      })
      .catch((err) => {
        setAmiResponse(err.message);
        setIsReviewing(false);
        console.log("err::", err);
      });
  };

  const resetCurrentPath = () => {
    let appPath = room?.slug
      ? singleClaimedRoomRoutes.path.replace(":slug", room.slug)
      : singleRoomRoutes.path.replace(":roomId", room._id);
    appPath =
      window.location.protocol +
      "//" +
      window.location.host +
      appPath +
      "/apps/" +
      app.slug;
    window.history.pushState({ path: appPath }, "", appPath);
  };
  const _renderDEOandCCRoomRequirement = () => {
    const { isCCRoom, isDAORoom } = room;
    const _renderMessage = () => {
      if (room.owner?._id === user?._id || room.owner === user?._id) {
        return (
          <p className="text-sm font-normal text-darkGray ">
            Access Granted! You are the host or moderator of this room.
          </p>
        );
      }
      if (!user?.bitclout_data?.bitclout_publickey) {
        return (
          <p className="text-sm font-normal text-darkGray ">
            To access this room you need to login with your deso account.
          </p>
        );
      }
      if (isDesoHodlerApproved) {
        return (
          <p className="text-sm font-normal text-darkGray ">
            Access Granted, you hold enough [Creator/DAO] Coins.
          </p>
        );
      }
      return (
        <div>
          {room?.isCCRoom && (
            <div>
              <p className="text-sm font-normal text-darkGray ">
                To join this room you are required to hold DeSo Creator Coins:
              </p>
              <div>
                {room.CCDetails.map((item, index) => (
                  <p
                    key={index}
                    className="flex text-sm gap-1 text-darkNight dark:text-frescoWhite"
                  >
                    <span>{item.amount}</span>
                    <span>{item.username}</span>
                    <span>Creator Coins</span>
                  </p>
                ))}
              </div>
            </div>
          )}
          {room?.isDAORoom && (
            <div>
              <p className="text-sm font-normal text-darkGray ">
                To join this room you are required to hold DeSo DAO Tokens:
              </p>
              <div>
                {room.DAODetails.map((item, index) => (
                  <p
                    key={index}
                    className="flex text-sm gap-1 text-darkNight dark:text-frescoWhite"
                  >
                    <span>{item.amount}</span>
                    <span>{item.token}</span>
                    <span>DAO Tokens</span>
                  </p>
                ))}
              </div>
            </div>
          )}
        </div>
      );
    };
    return (
      <div className="pr-10 pt-1 flex flex-col space-y-4 max-w-md mb-2">
        <div className="p-4 border border-lightGray dark:border-matteGray  rounded-xl">
          <div className="flex">
            <div className="pl-1 w-full">
              <p className="text-sm font-bold pb-2 text-darkNight dark:text-frescoWhite">
                {isCCRoom && isDAORoom
                  ? "Creator Coins and DAO Token"
                  : isCCRoom
                    ? "Creator Coins"
                    : " DAO Token"}{" "}
                room
              </p>
              {_renderMessage()}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const _renderDesoPostRoomRequirement = () => {
    const diamondLevel = getDiamondIconsFromDiamondLevel(
      room?.desoPostRoom?.diamondLevel,
    );
    const handleSendDiamondAsync = async (DiamondLevel) => {
      try {
        if (!user?.bitclout_data?.bitclout_publickey) {
          const message = `To access this room you need to login with your deso account`;
          showToast(dispatch, "", message, 2000);
          return;
        }
        if (!desoPost) return;
        setIsDiamondSending(true);
        await desoProtocol.sendDiamonds({
          SenderPublicKeyBase58Check: user?.bitclout_data?.bitclout_publickey,
          ReceiverPublicKeyBase58Check: desoPost?.PosterPublicKeyBase58Check,
          DiamondLevel: DiamondLevel,
          DiamondPostHashHex: desoPost.PostHashHex,
        });
        window.location.reload();
      } catch (error) {
        const apiError = error;
        if (apiError.message?.includes("_connectBasicTransferWithExtraSpend")) {
          showToast(
            dispatch,
            "error",
            "Insufficient balance to complete diamond transaction.",
            2000,
          );
        } else {
          showToast(dispatch, "error", apiError.message, 2000);
        }
      } finally {
        setIsDiamondSending(false);
      }
    };

    const handleSendDiamond = () => {
      const DiamondLevel = room?.desoPostRoom?.diamondLevel;
      const diamondAmount = diamondExchangeLists[DiamondLevel + 1];
      if (!user) {
        showLoginModal(dispatch);
        return;
      }
      if (!user?.bitclout_data?.bitclout_publickey) {
        const message = `To diamond this post you need to login with your deso account`;
        showToast(dispatch, "", message, 2000);
        return;
      }
      if (DiamondLevel > 3) {
        globals.showModal(
          "Diamond",
          <>
            <div className=" justify-center px-3 py-1.5 rounded-2xl  ">
              <div>
                <div className="flex flex-row py-2 items-center gap-4">
                  <div>
                    <p className="dark:text-frescoWhite">
                      Are you sure you want to send {diamondAmount} diamonds?
                    </p>
                  </div>
                </div>
              </div>
              <div className="pt-3 flex flex-row-reverse">
                <div className="space-x-2">
                  <Button
                    size="vibhut-sm"
                    variant="vibhut-secondary"
                    onClick={() => {
                      globals.hideModal();
                    }}
                  >
                    Close
                  </Button>
                  {isDiamondSending ? (
                    <Loader />
                  ) : (
                    <Button
                      disabled={isDiamondSending}
                      variant="primary"
                      onClick={() => {
                        globals.hideModal();
                        handleSendDiamondAsync(DiamondLevel);
                      }}
                    >
                      Confirm
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </>,
        );
        return;
      }
      handleSendDiamondAsync(DiamondLevel);
    };

    const _renderMessage = () => {
      if (room.owner?._id === user?._id || room.owner === user?._id) {
        return (
          <p className="text-sm font-normal text-darkGray ">
            Access Granted! You are the owner of this room.
          </p>
        );
      }
      if (!user?.bitclout_data?.bitclout_publickey) {
        return (
          <p className="text-sm font-normal text-darkGray ">
            To access this room you need to login with your deso account and
            provide {diamondLevel} to the below post.
          </p>
        );
      }
      if (isDesoPostDetailFetching) {
        return (
          <p className="rounded-md w-full animate-pulse bg-frescoWhite dark:bg-darkGray h-6"></p>
        );
      }
      if (isDesoPostApproved) {
        return (
          <p className="text-sm font-normal text-darkGray ">
            Access Granted! You have provided the required {diamondLevel} to
            join the room.
          </p>
        );
      }
      return (
        <>
          <p className="text-sm font-normal text-darkGray ">
            You need to provide <strong>{diamondLevel}</strong> diamonds to join
            this room.
          </p>
          <Button
            disabled={isDiamondSending}
            size="vibhut-sm-outline"
            variant="vibhut-primary-outline"
            onClick={handleSendDiamond}
          >
            {isDiamondSending ? (
              <span>Processing...</span>
            ) : (
              <span>
                Provide Diamonds<strong>{diamondLevel}</strong>
              </span>
            )}
          </Button>
        </>
      );
    };
    return (
      <div className="pr-10 pt-1 flex flex-col space-y-4 max-w-md mb-2">
        <div className="p-4 border border-lightGray dark:border-matteGray  rounded-xl">
          <div className="flex">
            <div>💎</div>
            <div className="pl-1 w-full">
              <p className="text-sm font-bold pb-2 text-darkNight dark:text-frescoWhite">
                Deso Post Room
              </p>
              {_renderMessage()}
            </div>
          </div>
          <span className="p-4 text-sm font-normal text-darkGray">
            See DeSo post{" "}
            <a
              href={`https://vibehut.io/feed/${room?.desoPostRoom?.postHashHex}`}
              target="_blank"
              className="text-primary cursor-pointer underline"
            >
              here
            </a>
          </span>
        </div>
      </div>
    );
  };

  if (isFetchingScreenRoom && !room) {
    return <RoomSkeleton isAppPage={isAppPage} />;
  }
  if (!room && !isFetchingScreenRoom) {
    return (
      <Empty
        Image={<NoConnections />}
        title="Room not found"
        showButton={true}
        description="We apologize for the inconvenience, but it seems that the room you have requested is not available at this time. It is possible that the room has been deleted or removed from our system."
      />
    );
  }

  const startCall = async (e) => {
    let joinInstantCall = false;
    if (e.shiftKey) {
      joinInstantCall = true;
    }
    if (!user) {
      if (room?.isGuestAllowed) {
        showLoginModal(dispatch, {
          joinCallAsGuest: true,
          guestCallUrl: `${videoAppUrl}/call?roomKey=${roomId}&guest=true`,
        });
      } else {
        showLoginModal(dispatch);
      }
      return;
    }

    if (!room) return;

    if (
      !isModerator() &&
      !isAccessPassHolder &&
      roomHasSubscription &&
      !isUserSubscribed
    ) {
      setIsSubscriptionOpen(true);
      return;
    }

    if (
      room.owner &&
      (room.owner?._id === user?._id || room.owner === user?._id)
    ) {
      goToCallPage(joinInstantCall);
      return;
    }

    if (room.blockedUsers?.includes(user?._id)) return;

    if (room?.isNftCollectionRoom) {
      if (room?.isAccessible) {
        goToCallPage(joinInstantCall);
      }
      showToast(
        dispatch,
        "",
        `In order to start a call, you need to own at least one NFT from the ${room?.name} Collection`,
        2000,
      );
      return;
    }
    if (room?.isSubscriberRequireApproval) {
      if (!room?.subscriberApprovedUsers?.includes(user._id)) {
        openJoinCallModal();
      }
      goToCallPage(joinInstantCall);
      return;
    }

    if (room?.planAccessible) {
      const userRole = getUserRole(role, user.serviceRole);

      const userPlan = userServiceRoleMap[userRole?._id].planRole.toUpperCase();
      const requiredPlan = room.planAccessible.toUpperCase();
      const planType = {
        FREE: 0,
        STARTER: 1,
        PRO: 2,
        BUSINESS: 3,
      };
      if (planType[userPlan] < planType[requiredPlan]) {
        showToast(
          dispatch,
          "",
          `To access this room you need to have a ${room?.planAccessible} plan
              ${room?.planAccessible !== "Business" ? "" : " and above."}`,
          2000,
        );
        return;
      }
    }

    if (room.desoPostRoom?.postHashHex) {
      if (!user?.bitclout_data?.bitclout_publickey) {
        const message = `To access this room you need to login with your deso account`;
        showToast(dispatch, "", message, 2000);
        return;
      }
      if (isDesoPostApproved) {
        goToCallPage(joinInstantCall);
      } else {
        const message = `You need to provide <strong>${getDiamondIconsFromDiamondLevel(
          room?.desoPostRoom?.diamondLevel,
        )}</strong>  diamonds to join this room.`;
        showToast(dispatch, "", message, 2000);
        return;
      }
    }

    if (room?.isCCRoom || room?.isDAORoom) {
      if (!user?.bitclout_data?.bitclout_publickey) {
        const message = `To access this room you need to login with your deso account`;
        showToast(dispatch, "", message, 2000);
        return;
      }
      if (isDesoHodlerApproved) {
        goToCallPage(joinInstantCall);
      } else {
        let requirementMessage = "";
        if (room?.isCCRoom && room?.isDAORoom) {
          requirementMessage = "Creator Coins and DAO Token";
        } else if (room?.isCCRoom) {
          requirementMessage = "Creator Coins";
        } else {
          requirementMessage = "DAO Token";
        }
        const message = `You need to hold ${requirementMessage} to join this room.`;
        showToast(dispatch, "", message, 2000);
        return;
      }
    }

    const roomAccess = await checkLiveEventAndIfUserIsSubscribed();
    if (roomAccess) {
      goToCallPage(joinInstantCall);
    }
  };

  const _renderPasswordRequired = () => {
    return (
      <div className="pr-10 pt-1 flex flex-col space-y-4 max-w-md mb-2">
        <div className="flex p-4 border border-lightGray dark:border-matteGray  rounded-xl">
          <div className="pt-0.5">
            <Lock ratio="18" />
          </div>
          <div className="pl-1">
            <p className="text-sm font-bold pb-2 text-darkNight dark:text-frescoWhite">
              Password
            </p>
            <p className="text-sm font-normal text-darkGray ">
              The creator of the room has put a password on this room. It will
              be asked for when you start a call.
            </p>
          </div>
        </div>
      </div>
    );
  };

  const openJoinCallModal = () => {
    let isSubscriberApproved = false;
    (room?.subscriberApprovedUsers || []).forEach((subscriberApprovedUser) => {
      if (user && subscriberApprovedUser.toString() === user._id.toString()) {
        isSubscriberApproved = true;
      }
    });
    globals.showModal(
      "Approval Required",
      <div className="text-darkGray dark:text-frescoWhite flex">
        {approvalStatusText(isSubscriberApproved)}
      </div>,
    );
  };

  const approvalStatusText = (isSubscriberApproved) => {
    if (room?.owner?._id === user?._id)
      return "You are the host of this room and can join.";
    if (
      (isSubscriberApproved && roomSubscriberApprovalStatus !== "Declined") ||
      roomSubscriberApprovalStatus === "Approved"
    ) {
      return "You have been approved to join this room.";
    }
    if (roomSubscriberApprovalStatus === "Pending") {
      return "You have requested permission from the host and are waiting on their approval.";
    }

    if (roomSubscriberApprovalStatus === "Declined") {
      return "Unfortunately the host has declined your approval.";
    }

    if (roomSubscriberApprovalStatus === "Invited") {
      return (
        <div className="flex flex-col gap-2">
          <p>You are invited by the host; please accept your invitation.</p>
          <div className="flex space-x-2">
            <NotificationUpdate
              totalSubscribedUsers={totalSubscribedRooms}
              roomId={room?._id}
              roomOwner={room?.owner?._id}
              blockedUsers={room.blockedUsers || []}
              showChatIcon={false}
              reloadPage={true}
              isSubscriberRequireApproval={room?.isSubscriberRequireApproval}
              roomSubscriberApprovalStatus={roomSubscriberApprovalStatus}
            />
          </div>
        </div>
      );
    }
    return (
      <div className="flex flex-col gap-2">
        <p>
          To join this room, you need permission from the host. Please subscribe
          the room.
        </p>
        <div className="flex space-x-2">
          <NotificationUpdate
            totalSubscribedUsers={totalSubscribedRooms}
            roomId={room?._id}
            roomOwner={room?.owner?._id}
            blockedUsers={room.blockedUsers || []}
            showChatIcon={false}
            reloadPage={true}
            isSubscriberRequireApproval={room?.isSubscriberRequireApproval}
            roomSubscriberApprovalStatus={roomSubscriberApprovalStatus}
          />
        </div>
      </div>
    );
  };

  const approvalStatusTitle = (
    isSubscriberApproved,
    roomSubscriberApprovalStatus,
  ) => {
    let statusTitle = "Subscriber Approval";
    if (
      (isSubscriberApproved && roomSubscriberApprovalStatus !== "Declined") ||
      roomSubscriberApprovalStatus === "Approved"
    ) {
      statusTitle = "Approved";
    }
    if (roomSubscriberApprovalStatus === "Pending") {
      statusTitle = "Pending Approval";
    }

    if (roomSubscriberApprovalStatus === "Declined") {
      statusTitle = "Declined Approval";
    }
    return statusTitle;
  };

  const _renderSubscriberApprovalRequired = (subscriberApprovedUsers) => {
    let isSubscriberApproved = false;
    subscriberApprovedUsers.forEach((subscriberApprovedUser) => {
      if (user && subscriberApprovedUser.toString() === user._id.toString()) {
        isSubscriberApproved = true;
      }
    });
    return (
      <div className="pr-10 pt-1 flex flex-col space-y-4 max-w-md mb-2">
        <div className="flex p-4 border border-lightGray dark:border-matteGray  rounded-xl">
          <div className="pt-0.5">
            {isSubscriberApproved && <SubscriberApproved ratio="18" />}
            {!isSubscriberApproved && <SubscriberApproval ratio="18" />}
          </div>
          <div className="pl-1">
            <p className="text-sm font-bold pb-2 text-darkNight dark:text-frescoWhite">
              {approvalStatusTitle(
                isSubscriberApproved,
                roomSubscriberApprovalStatus,
              )}
            </p>
            <p className="text-sm font-normal text-darkGray ">
              {approvalStatusText(isSubscriberApproved)}
            </p>
            {roomSubscriberApprovalStatus === "Pending" && (
              <p className="italic text-sm text-darkGray">
                Requested on{" "}
                {moment(roomSubscriberApprovalDate).format("MMM D, h:mma z")}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  };

  const _renderPlanSubRequirement = () => {
    const userRole = getUserRole(role, user?.serviceRole);
    const userPlan = userServiceRoleMap[userRole?._id]?.planRole.toUpperCase();
    const requiredPlan = room.planAccessible.toUpperCase();
    const planType = {
      FREE: 0,
      STARTER: 1,
      PRO: 2,
      BUSINESS: 3,
    };
    if (planType[userPlan] >= planType[requiredPlan]) {
      const iconFillColor = calcPlanIconColor(room.planAccessible);
      return (
        <div className="pr-10 pt-1 flex flex-col space-y-4 max-w-md mb-2">
          <div className="flex p-4 border border-lightGray dark:border-matteGray  rounded-xl">
            <PaidBadgeRaw
              color={iconFillColor}
              ratio="16"
              customClass="mt-0.5"
            />
            <div className="pl-1">
              <p className="text-sm font-bold pb-2 text-darkNight dark:text-frescoWhite">
                Plan Approved
              </p>
              <p className="text-sm font-normal text-darkGray ">
                You're in! You have a{" "}
                <span className="font-bold">{room.planAccessible} plan</span> or
                above.
              </p>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="pr-10 pt-1 flex flex-col space-y-4 max-w-md mb-2">
        <div className="flex p-4 border border-lightGray dark:border-matteGray  rounded-xl">
          <div className="pt-0.5">
            <Polygon bgColor="#B5B5B5" />
          </div>
          <div className="pl-1">
            <p className="text-sm font-bold pb-2 text-darkNight dark:text-frescoWhite">
              Plan Required
            </p>
            <p className="text-sm font-normal text-darkGray ">
              To access this room you need to have a {room?.planAccessible} plan
              {room?.planAccessible !== "Business" && " and above."}
            </p>
          </div>
        </div>
      </div>
    );
  };

  const _renderSubscriptionRequired = (amount) => {
    return (
      <div className="pr-10 py-3 flex flex-col space-y-4 max-w-md">
        <div className="flex p-4 border border-lightGray dark:border-matteGray  rounded-xl">
          <div className="pt-0.5">
            <Subscriptions />
          </div>
          <div className="pl-1">
            <p className="text-sm font-bold pb-2 text-darkNight dark:text-frescoWhite">
              {room?.subscriptionType === "monthly"
                ? "Subscription"
                : "Payment"}
            </p>
            <p className="text-sm font-normal text-darkGray ">
              {room?.subscriptionType === "monthly"
                ? `To take advantage of everything this room has to offer, you can
              subscribe for $${Number(amount).toFixed(2)} / month.`
                : `To take advantage of everything this room has to offer it costs $${Number(
                    amount,
                  ).toFixed(2)} to join.`}
            </p>
            <p className="mt-2">
              <Button
                size="vibhut-sm-outline"
                variant="vibhut-primary-outline"
                onClick={() => {
                  if (!user) {
                    return showLoginModal(dispatch);
                  }
                  setIsSubscriptionOpen(true);
                }}
              >
                {`Join for $${Number(amount).toFixed(2)}`}
              </Button>
            </p>
          </div>
        </div>
      </div>
    );
  };
  const _renderSubscribedUser = () => {
    return (
      <div className="pr-10 py-3 flex flex-col space-y-4 max-w-md">
        <div className="flex p-4 border border-lightGray dark:border-matteGray  rounded-xl">
          <div className="pt-1">
            <Subscriptions />
          </div>
          <div className="pl-1">
            <p className="text-sm font-bold pb-2 text-darkNight dark:text-frescoWhite">
              {room?.subscriptionType === "monthly" ? "Subscribed" : "Paid"}
            </p>
            <p className="text-sm font-normal text-darkGray ">
              You are subscribed. You can now take advantage of everything this
              room has to offer.
            </p>
            {room?.subscriptionType === "monthly" && (
              <p className="mt-4">
                {isNextRenewal ? (
                  <Button
                    size="vibhut-sm-outline"
                    variant="vibhut-primary-outline"
                    onClick={() => setIsSubscriptionOpen(true)}
                  >
                    Unsubscribe
                  </Button>
                ) : (
                  <p className="text-sm font-normal text-darkGray">
                    Your subscription will
                    <span className="text-sm font-bold pb-2 text-darkNight dark:text-frescoWhite">
                      &nbsp; expire on{" "}
                      {moment(subscriptionData.nextRenewal).format(
                        "MMMM Do YYYY",
                      )}
                      .
                    </span>
                  </p>
                )}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  };
  const _renderOwnerSubscriber = () => {
    return (
      <div className="pr-10 py-3 flex flex-col space-y-4 max-w-md">
        <div className="flex p-4 border border-lightGray dark:border-matteGray  rounded-xl">
          <div className="pt-0.5">
            <Subscriptions color={"#34C759"} />
          </div>
          <div className="pl-1">
            <p className="text-sm font-bold pb-2 text-darkNight dark:text-frescoWhite">
              {room?.subscriptionType === "monthly"
                ? "Subscription"
                : "Payment"}
            </p>
            <p className="text-sm font-normal text-darkGray ">
              {room?.subscriptionType === "monthly"
                ? `You're the creator! This room requires people to pay $${parseFloat(
                    room?.subscriptionAmount,
                  ).toFixed(2)}/month to enjoy its full benefits.`
                : `You're the creator! This room requires people to pay $${parseFloat(
                    room?.subscriptionAmount,
                  ).toFixed(2)} one-time to enjoy its full benefits.`}
            </p>
          </div>
        </div>
      </div>
    );
  };

  const _renderAuthActionButtons = () => {
    if (
      user?._id &&
      room.owner &&
      (room.owner._id === user?._id || room.owner === user?._id)
    ) {
      return (
        <div
          className="flex items-center"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <Menu as="div" className="relative inline-block text-left">
            <div className="flex items-center">
              <Menu.Button className="">
                <OptionButton />
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 w-56 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                <div className="px-1 py-1 ">
                  <Menu.Item>
                    <button
                      onClick={() => setIsEditOpen(true)}
                      className={`group flex rounded-md hover:text-primary items-center justify-between w-full px-2 py-2 text-sm`}
                    >
                      <span className="">Edit</span>
                      <Edit />
                    </button>
                  </Menu.Item>
                  <Menu.Item>
                    <button
                      onClick={() => setIsDeleteOpen(true)}
                      className={`group flex rounded-md items-center justify-between w-full px-2 py-2 text-sm`}
                    >
                      <span className="text-cvRed">Delete</span>
                      <Trash />
                    </button>
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      );
    }
    return <></>;
  };

  const _renderEventTime = () => {
    const zone = event.creatorTimeZone || moment.tz.guess();
    var startTime = moment(event.startDate).tz(zone);
    var endTime = moment(event.endDate).tz(zone);

    let timeRangeString = "";
    const isAMsame = startTime.format("a") === endTime.format("a");
    if (startTime.format("mm") === "00") {
      timeRangeString =
        timeRangeString + startTime.format(`h${isAMsame ? "" : " A"}`);
    } else {
      timeRangeString =
        timeRangeString + startTime.format(`h:mm${isAMsame ? "" : " A"}`);
    }
    timeRangeString = timeRangeString + "-";
    if (endTime.format("mm") === "00") {
      timeRangeString = timeRangeString + endTime.format("h A");
    } else {
      timeRangeString = timeRangeString + endTime.format("h:mm A");
    }
    const abbr = moment.tz(zone).format("z");

    if (endTime < new Date()) {
      return `${startTime.format("ddd, MMM D,")} ${timeRangeString} ${abbr}`;
    }

    return `${startTime.format("ddd, MMM D,")} ${timeRangeString} ${abbr}`;
  };

  const componentDecorator = (href, text, key) => (
    <a
      href={href}
      key={key}
      target="_blank"
      className="text-primary text-weight-bold break-words"
      rel="noreferrer"
    >
      {text}
    </a>
  );

  const getModeratorData = async () => {
    await getModeratorsByRoomId(roomId, user?.token)
      .then((res) => {
        openUserModeratorModal(res.data.moderators);
      })
      .catch((err) => {
        console.log("err::", err);
      });
  };

  const openUserModeratorModal = (moderators) => {
    globals.showModal(
      `Moderators · ${moderators.length}`,
      <>
        <div className="overflow-y-auto custom-scrollbar h-80  px-2 flex flex-col gap-1 divide-y dark:divide-matteGray">
          {moderators.map((moderator, index) => (
            <div
              key={index}
              className="flex justify-between items-center  py-1 "
            >
              <UserCard user={getUserData(moderator)} size="sm-3" />
              <div>
                <Button
                  onClick={() => {
                    globals.hideModal();
                    history.push(
                      profileRoute.path.replace(
                        ":username",
                        moderator?.vibehutUsername || moderator._id,
                      ),
                    );
                  }}
                  variant="secondary"
                >
                  View Profile
                </Button>
              </div>
            </div>
          ))}
        </div>
      </>,
    );
  };

  const handleLoadMoreRoomEvents = async () => {
    await getRoomEvents(
      user?.token,
      dispatch,
      roomId,
      isMoreRoomEvents,
      roomEventsOffset,
    );
  };

  const path = room?.slug
    ? singleClaimedRoomRoutes.path.replace(":slug", room.slug)
    : singleRoomRoutes.path.replace(":roomId", room._id);

  const _renderMetaTags = () => {
    if (appSlug && app) {
      let path = "";
      if (room?.slug) {
        path = `${singleClaimedRoomRoutes.path.replace(
          ":slug",
          room.slug,
        )}/apps/${app.slug}`;
      } else {
        path = `${singleRoomRoutes.path.replace(":roomId", room._id)}/apps/${
          app.slug
        }`;
      }
      return (
        <Helmet>
          <title>{`Vibehut - ${app?.name || ""}`}</title>
          <meta
            name="description"
            content={
              app?.description ||
              "Let’s see what @Ami has to say about your writing!"
            }
          />
          {/* <!-- Facebook Meta Tags --> */}
          <meta property="og:url" content={`https://vibehut.io${path}/`} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={`Vibehut - ${app?.name || ""}`} />
          <meta
            property="og:description"
            content={
              app?.description ||
              "Let’s see what @Ami has to say about your writing!"
            }
          />
          <meta
            property="og:image"
            content={
              app?.coverImageUrl !== null
                ? app?.coverImageUrl
                : room?.cover?.urls?.regular
            }
          />

          {/* <!-- Twitter Meta Tags -- > */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta property="twitter:domain" content={domain} />
          <meta property="twitter:url" content={`https://vibehut.io${path}/`} />
          <meta name="twitter:title" content={`Vibehut - ${app?.name || ""}`} />
          <meta
            name="twitter:description"
            content={
              app?.description ||
              "Let’s see what @Ami has to say about your writing!"
            }
          />
          <meta
            name="twitter:image"
            content={
              app?.coverImageUrl !== null
                ? app?.coverImageUrl
                : room?.cover?.urls?.regular
            }
          />
        </Helmet>
      );
    }
    return (
      <Helmet>
        <title>
          {event !== null
            ? `${event?.title} | Vibehut`
            : `Vibehut - ${room?.name} Room`}
        </title>
        <meta
          name="description"
          content={
            event !== null
              ? `${event && _renderEventTime()}: ${event?.title} in ${
                  room?.name
                }`
              : `Have a ${
                  room.isGroupRoom ? "group" : "1-on-1"
                } video call now about ${room.name}. Leave anytime!`
          }
        />
        {/* <!-- Facebook Meta Tags --> */}
        <meta
          property="og:url"
          content={
            event !== null
              ? `https://vibehut.io${path}/events/${eventId}`
              : `https://vibehut.io${path}/`
          }
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={
            event !== null
              ? `${event?.title} | Vibehut`
              : `Vibehut - ${room?.name} Room`
          }
        />
        <meta
          property="og:description"
          content={
            event !== null
              ? `${event && _renderEventTime()}: ${event?.title} in ${
                  room?.name
                }`
              : `Have a ${
                  room.isGroupRoom ? "group" : "1-on-1"
                } video call now about ${room.name}. Leave anytime!`
          }
        />
        <meta
          property="og:image"
          content={
            event !== null
              ? event?.cover?.urls?.regular
              : room?.cover?.urls?.regular
          }
        />

        {/* <!-- Twitter Meta Tags -- > */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content={domain} />
        <meta
          property="twitter:url"
          content={
            event !== null
              ? `https://vibehut.io/${roomId}/events/${eventId}`
              : `https://vibehut.io/${roomId}/`
          }
        />
        <meta
          name="twitter:title"
          content={
            event !== null
              ? `${event?.title} | Vibehut`
              : `Vibehut - ${room?.name} Room`
          }
        />
        <meta
          name="twitter:description"
          content={
            event !== null
              ? `${event && _renderEventTime()}: ${event?.title} in ${
                  room?.name
                }`
              : `Have a ${
                  room.isGroupRoom ? "group" : "1-on-1"
                } video call now about ${room.name}. Leave anytime!`
          }
        />
        <meta
          name="twitter:image"
          content={
            event !== null
              ? event?.cover?.urls?.regular
              : room?.cover?.urls?.regular
          }
        />
      </Helmet>
    );
  };

  return (
    <div>
      {_renderMetaTags()}
      <div className=" -mx-[23px] sm:-mx-12 mb-4 md:mb-10 ">
        <img
          src={
            room?.cover?.urls?.regular ||
            `${process.env.PUBLIC_URL}/images/Frame 61.png`
          }
          alt="banner"
          className="w-full object-cover md:h-64 h-56"
          loading="lazy"
        />
      </div>
      <div className="border-b dark:border-matteGray pb-6 ">
        <div className="flex items-center justify-between md:pt-0 pt-4 space-y-3 md:space-y-0 md:flex-row flex-col">
          <div className="flex items-center gap-2">
            <p className="font-bold text-xl text-darkNight dark:text-frescoWhite max-w-sm  lg:max-w-sm  xl:max-w-sm 2xl:max-w-md 3xl:max-w-xl custom-line-clamp">
              {room?.name.replace(" with $(_user)", "")}
            </p>
          </div>

          <div className="inline-flex flex-wrap gap-y-3 space-x-3 z-10 items-center justify-center">
            <button
              onClick={() => setIsEmbedOpen(true)}
              className={`w-9 h-9
                bg-frescoWhite text-navyGray
               rounded-full flex items-center justify-center cursor-pointer`}
            >
              <Code />
            </button>

            <CopyButton
              title={`Vibehut - ${room?.name}`}
              url={`${window.location.href}`}
              bgColor="transparent"
            />
            <span
              onClick={() => setIsQRModalOpen(true)}
              className="p-2 cursor-pointer flex justify-center rounded-full items-center bg-frescoWhite"
            >
              <QRIcon ratio={20} />
            </span>
            {width < 768 && _renderAuthActionButtons()}
            <NotificationUpdate
              totalSubscribedUsers={totalSubscribedRooms}
              roomId={room?._id}
              roomOwner={room?.owner?._id}
              blockedUsers={room.blockedUsers || []}
              isSubscriberRequireApproval={room?.isSubscriberRequireApproval}
              roomSubscriberApprovalStatus={roomSubscriberApprovalStatus}
            />
            {width >= 768 && _renderAuthActionButtons()}

            <div className="relative">
              {!isShiftKeyDown ? (
                <Button
                  size="vibhut-sm"
                  variant="vibhut-primary"
                  onClick={startCall}
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                >
                  {" "}
                  {room?.isSubscriberRequireApproval &&
                    showTooltip &&
                    !isModerator() &&
                    !isAccessPassHolder &&
                    !room.subscriberApprovedUsers?.includes(user?._id) && (
                      <PopOver
                        text="Owner Approval required"
                        leftPosition={"-left-4"}
                        size={28}
                      />
                    )}
                  {showTooltip && room.blockedUsers?.includes(user?._id) && (
                    <PopOver
                      text="Blocked"
                      leftPosition={"-left-4"}
                      size={28}
                    />
                  )}
                  {showTooltip && room.isQuickJoin && (
                    <PopOver
                      text="Hold shift to instant join"
                      leftPosition={"-left-4"}
                      size={28}
                    />
                  )}
                  Join Call
                </Button>
              ) : (
                <InstantJoinCallButton room={room} />
              )}

              {room?.isNftCollectionRoom &&
                !room?.isPasswordProtected &&
                showTooltip &&
                (!room.isAccessible ? (
                  <PopOver
                    text="NFT required"
                    leftPosition={"-left-4"}
                    size={28}
                  />
                ) : undefined)}

              {!room?.moderators?.includes(user?._id) &&
                roomHasSubscription &&
                !isUserSubscribed &&
                showTooltip && (
                  <PopOver
                    text="Subscription required"
                    leftPosition={"-left-10"}
                    size={40}
                  />
                )}
            </div>
          </div>
        </div>
        {room?.owner ? (
          <div className="flex pt-2">
            <UserCard user={getUserData(room?.owner)} subtitle="Creator" />
            {room.moderators?.length > 0 && (
              <p
                className={`font-ubuntu text-sm font-normal cursor-pointer text-primary py-2`}
                onClick={getModeratorData}
              >
                {" +"}
                {room.moderators?.length || 0}{" "}
                {room.moderators?.length === 1 ? "Moderator" : "Moderators"}
              </p>
            )}
          </div>
        ) : undefined}
      </div>
      {appSlug ? (
        app ? (
          <div className="w-full flex md:flex-row flex-col pt-4 pb-4">
            <p className="flex-col w-full">
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-xl block font-bold text-black dark:text-frescoWhite">
                    {app.name || ""}
                  </p>
                  <p className="text-xs text-darkGray items-start text-left font-normal tracking-wide ">
                    {app.description ||
                      "Let’s see what @Ami has to say about your writing!"}
                  </p>
                </div>
                <div>
                  <SpecificChat
                    chatItem={{ ...app, owner: room?.owner?._id }}
                    type="prompt"
                  />
                </div>
              </div>
              <p className="text-base font-medium	mt-8 dark:text-frescoWhite flex-col flex ">
                {app.inputHeader || "Writing to review"}
              </p>

              <LimitedTextarea
                limit={4000}
                value={writingDescription}
                rows={5}
                onChange={handleDescriptionChange}
                placeHolder={
                  app.inputLabel || "Type or paste your writing in here... "
                }
              />
              <p className="text-xs text-darkGray items-start text-left font-normal tracking-wide flex">
                If there was a question, provide the context at the top.
              </p>
              <div className="mt-4 flex">
                {isReviewing ? (
                  <Loader />
                ) : (
                  <Button
                    size="vibhut-sm"
                    variant="vibhut-primary"
                    onClick={reviewWrting}
                  >
                    {app.buttonLabel || "Review My Writing"}
                  </Button>
                )}
                <Button
                  size="vibhut-sm"
                  onClick={resetWriting}
                  customClasses={"ml-1"}
                  variant="vibhut-secondary"
                >
                  Reset
                </Button>
              </div>
              <div className="flex justify-between items-center mt-8">
                <div>
                  <p className="text-base font-medium dark:text-frescoWhite flex-col flex ">
                    {app.outputHeader || "Your Writing Review"}
                  </p>
                  {app.reviewedCount && app.reviewedCount > 0 && (
                    <p className="text-sm font-medium	 text-darkGray  flex-col flex ">
                      {app.reviewedCount} reviews completed
                    </p>
                  )}
                </div>

                <div className=" border-gray-600 cursor-pointer text-sm flex">
                  {!isMobile() && (
                    <div className="mr-2">
                      <CopyButton
                        buttonTitle={app.copyTextLabel || "Copy Text"}
                        copyText={amiResponse}
                        bgColor="transparent"
                        type="button"
                        showIcon={true}
                        leftPosition={"left-4"}
                        cssClasses={`ml-1 cusBtn cusBtn-vibhut-secondary cusBtn-vibhut-sm flex-wrap`}
                        disabled={promptIdVal ? false : true}
                      />
                    </div>
                  )}
                  <CopyButton
                    buttonTitle={app.shareLabel || "Share"}
                    url={`${window.location.href}/response/${promptIdVal}`}
                    bgColor="transparent"
                    type="button"
                    showIcon={true}
                    leftPosition={"left-2"}
                    cssClasses={`ml-1 cusBtn cusBtn-vibhut-secondary cusBtn-vibhut-sm flex-wrap`}
                    disabled={promptIdVal ? false : true}
                  />
                </div>
              </div>
              <div
                className="my-1 py-2 px-4 overflow-x-auto text-sm whitespace-pre-wrap"
                style={{
                  background: "#F2F2F2",
                  "border-radius": "16px",
                  minHeight: "14rem",
                }}
              >
                {amiResponse.trim().length > 0
                  ? ReactHtmlParser(amiResponse)
                  : "Hey - I'm @Ami, ready to help!"}
              </div>
            </p>
          </div>
        ) : undefined
      ) : isAppPage ? (
        <React.Fragment>
          <div className="flex justify-between items-center mt-4 pb-4">
            <p className="text-xl	flex-grow font-medium text-black dark:text-frescoWhite">
              AI Applications
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 3xl:grid-cols-4 grid-cols-1 gap-8 py-5">
            {apps?.map((app) => {
              let path = "";
              if (room?.slug) {
                path = `${singleClaimedRoomRoutes.path.replace(
                  ":slug",
                  room.slug,
                )}/apps/${app.slug}`;
              } else {
                path = `${singleRoomRoutes.path.replace(
                  ":roomId",
                  room._id,
                )}/apps/${app.slug}`;
              }
              return (
                <Link key={app._id} to={path}>
                  <div className="cursor-pointer max-w-md" key={app._id}>
                    <AppCard app={app} />
                  </div>
                </Link>
              );
            })}
          </div>
        </React.Fragment>
      ) : (
        <div className="w-full flex md:flex-row flex-col pt-4">
          <div className="md:w-1/2 w-full">
            <div className=" max-w-md md:pr-10">
              {room.description ? (
                <div>
                  <p className="text-base font-bold pb-2 text-black dark:text-frescoWhite">
                    Description
                  </p>
                  <p
                    className={`text-sm font-normal text-darkGray whitespace-pre-wrap ${
                      !showFullText && "custom-five-line-clamp"
                    }`}
                  >
                    <Linkify componentDecorator={componentDecorator}>
                      {room.description}
                    </Linkify>
                  </p>
                  {room?.description?.length >= actionTypes.LINE_CHAR * 5 && (
                    <button
                      onClick={() => {
                        setShowFullText(!showFullText);
                      }}
                      className="text-primary hover:underline cursor-pointer text-sm"
                    >
                      {showFullText ? "See Less" : "See More"}
                    </button>
                  )}
                </div>
              ) : undefined}

              {room?.isPasswordProtected ||
              room?.isNftCollectionRoom ||
              room?.isSubscriberRequireApproval ||
              room?.hasSubscription ||
              room?.planAccessible ||
              room?.desoPostRoom ||
              room?.isCCRoom ||
              room?.isDAORoom ? (
                <div className=" w-full pt-4">
                  <p className="text-base font-bold pb-4 text-darkNight dark:text-frescoWhite">
                    Requirements
                  </p>
                  {room?.planAccessible && _renderPlanSubRequirement()}

                  {room?.isNftCollectionRoom ? (
                    room?.isAccessible ? (
                      <div className="">
                        {room?.nftCollectionSlugsMapping?.length ? (
                          <NFTRoomCard
                            iconColor={
                              room?.isAccessible ? "#FFCC00" : "#B5B5B5"
                            }
                            detail={
                              <React.Fragment>
                                You are golden! You own a NFT that is required
                                to access this room:
                                {room?.nftCollectionSlugsMapping.map(
                                  (slug, index) => (
                                    <p key={index}>
                                      <a
                                        href={
                                          slug?.url || slug?.type === "opensea"
                                            ? `https://opensea.io/collection/${slug.title}`
                                            : `https://diamondapp.com/nft/${slug.title}`
                                        }
                                        className="text-primary cursor-pointer z-50 break-all"
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {slug.title}
                                      </a>
                                      {index !==
                                        room?.nftCollectionSlugsMapping.length -
                                          1 && (
                                        <div
                                          className={`border-b dark:border-matteGray h-px my-2`}
                                        ></div>
                                      )}
                                    </p>
                                  ),
                                )}
                              </React.Fragment>
                            }
                          />
                        ) : room?.nftCollectionSlugs?.length ? (
                          <NFTRoomCard
                            iconColor={
                              room?.isAccessible ? "#FFCC00" : "#B5B5B5"
                            }
                            detail={
                              <React.Fragment>
                                You are golden! You own a NFT that is required
                                to access this room:
                                {room?.nftCollectionSlugs.map((slug) => (
                                  <p key={index}>
                                    <a
                                      href={`https://opensea.io/collection/${slug}`}
                                      className="text-primary cursor-pointer z-50"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {slug}
                                    </a>
                                  </p>
                                ))}
                              </React.Fragment>
                            }
                          />
                        ) : (
                          <NFTRoomCard
                            iconColor={
                              room?.isAccessible ? "#FFCC00" : "#B5B5B5"
                            }
                            detail={
                              <React.Fragment>
                                You are golden! You own a NFT that is required
                                to access this room:
                                <p>
                                  You are golden! You own a NFT that is required
                                  to access this room:
                                  <a
                                    href={`https://opensea.io/collection/${room?.nftCollectionSlug}`}
                                    className="text-primary cursor-pointer z-50"
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {room?.name} Collection
                                  </a>
                                </p>
                              </React.Fragment>
                            }
                          />
                        )}
                      </div>
                    ) : (
                      <div className="">
                        {room?.nftCollectionSlugsMapping?.length ? (
                          <NFTRoomCard
                            iconColor={
                              room?.isAccessible ? "#FFCC00" : "#B5B5B5"
                            }
                            detail={
                              <React.Fragment>
                                In order to start a call, you need to own at
                                least one NFT from any of these NFT collections:
                                {room?.nftCollectionSlugsMapping.map(
                                  (nft, index) => (
                                    <p key={index}>
                                      <h3 className="font-bold py-0.5 text-darkNight dark:text-frescoWhite">
                                        {nft.type === "opensea"
                                          ? "OpenSea"
                                          : "DeSo"}{" "}
                                        NFT
                                      </h3>
                                      <a
                                        href={
                                          nft?.url
                                            ? nft.url
                                            : nft.type === "opensea"
                                              ? `https://opensea.io/collection/${nft.title}`
                                              : `https://diamondapp.com/nft/${nft.title}`
                                        }
                                        className="text-primary underline cursor-pointer z-50 break-all"
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {nft.title}
                                      </a>
                                      {index !==
                                        room?.nftCollectionSlugsMapping.length -
                                          1 && (
                                        <div
                                          className={`border-b dark:border-matteGray h-px my-2`}
                                        ></div>
                                      )}
                                    </p>
                                  ),
                                )}
                              </React.Fragment>
                            }
                          />
                        ) : room?.nftCollectionSlugs?.length ? (
                          <NFTRoomCard
                            iconColor={
                              room?.isAccessible ? "#FFCC00" : "#B5B5B5"
                            }
                            detail={
                              <React.Fragment>
                                In order to start a call, you need to own at
                                least one NFT from any of these NFT collections:
                                {room?.nftCollectionSlugs.map((slug) => (
                                  <p key={index}>
                                    <a
                                      href={`https://opensea.io/collection/${slug}`}
                                      className="text-primary cursor-pointer z-50"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {slug}
                                    </a>
                                  </p>
                                ))}
                              </React.Fragment>
                            }
                          />
                        ) : (
                          <NFTRoomCard
                            iconColor={
                              room?.isAccessible ? "#FFCC00" : "#B5B5B5"
                            }
                            detail={
                              <React.Fragment>
                                In order to start a call, you need to own at
                                least one NFT from the&nbsp;
                                <a
                                  href={`https://opensea.io/collection/${room?.nftCollectionSlug}`}
                                  className="text-primary cursor-pointer z-50"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {room?.name} Collection
                                </a>
                              </React.Fragment>
                            }
                          />
                        )}
                      </div>
                    )
                  ) : undefined}
                  {room?.isPasswordProtected
                    ? _renderPasswordRequired()
                    : undefined}
                  {room?.isSubscriberRequireApproval
                    ? _renderSubscriberApprovalRequired(
                        room?.subscriberApprovedUsers || [],
                      )
                    : undefined}
                  {roomHasSubscription && !isUserSubscribed
                    ? _renderSubscriptionRequired(
                        parseFloat(room.subscriptionAmount).toFixed(2),
                      )
                    : undefined}
                  {roomHasSubscription && isUserSubscribed
                    ? _renderSubscribedUser(room.subscriptionAmount)
                    : undefined}
                  {user &&
                    room.owner._id === user?._id &&
                    room?.hasSubscription &&
                    _renderOwnerSubscriber()}

                  {room?.desoPostRoom?.postHashHex &&
                    _renderDesoPostRoomRequirement()}
                  {(room?.isCCRoom || room?.isDAORoom) &&
                    _renderDEOandCCRoomRequirement()}
                </div>
              ) : undefined}
            </div>

            <div
              className={`${
                room.description ||
                room.isPasswordProtected ||
                room.isSubscriberRequireApproval ||
                room.isNftCollectionRoom
                  ? "pt-4"
                  : undefined
              }`}
            >
              <div className="md:pr-10 flex flex-col  max-w-md ">
                <div
                  className={`flex justify-between items-center text-black text-base font-bold dark:text-frescoWhite ${
                    room.description ||
                    room.isPasswordProtected ||
                    room?.isSubscriberRequireApproval ||
                    room.isNftCollectionRoom
                      ? "pt-4"
                      : undefined
                  }`}
                >
                  <p>Call Details</p>
                </div>
                {room.is_private ? (
                  <>
                    <div className="flex flex-row justify-start items-center mt-4">
                      <div
                        className="w-10 h-10 dark:text-frescoWhite border rounded-full flex justify-center items-center"
                        style={{ minWidth: 40 }}
                      >
                        <HidEye />
                      </div>

                      <div className="font-normal text-sm text-darkGray ml-4">
                        This room is unlisted.
                      </div>
                    </div>
                    <div
                      className={`border-b dark:border-matteGray h-px 
                       mt-4
                      `}
                    ></div>
                  </>
                ) : undefined}

                {room.isGroupRoom ? (
                  <div>
                    {room.maxUsersPerGroup ? (
                      <div className="flex flex-row justify-start items-center mt-4">
                        <div
                          className="w-10 h-10 dark:text-frescoWhite border rounded-full flex justify-center items-center"
                          style={{ minWidth: 40 }}
                        >
                          <svg
                            width="20"
                            height="21"
                            aria-hidden="true"
                            focusable="false"
                            viewBox="0 0 20 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.1654 18V16.3333C14.1654 15.4493 13.8142 14.6014 13.1891 13.9763C12.5639 13.3512 11.7161 13 10.832 13H4.16536C3.28131 13 2.43346 13.3512 1.80834 13.9763C1.18322 14.6014 0.832031 15.4493 0.832031 16.3333V18"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.5013 9.66667C9.34225 9.66667 10.8346 8.17428 10.8346 6.33333C10.8346 4.49238 9.34225 3 7.5013 3C5.66035 3 4.16797 4.49238 4.16797 6.33333C4.16797 8.17428 5.66035 9.66667 7.5013 9.66667Z"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M19.168 18.0001V16.3334C19.1674 15.5948 18.9216 14.8774 18.4691 14.2937C18.0166 13.7099 17.3831 13.293 16.668 13.1084"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M13.332 3.1084C14.049 3.29198 14.6846 3.70898 15.1384 4.29366C15.5922 4.87833 15.8386 5.59742 15.8386 6.33757C15.8386 7.07771 15.5922 7.7968 15.1384 8.38147C14.6846 8.96615 14.049 9.38315 13.332 9.56673"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>

                        <div className="font-normal text-sm text-darkGray ml-4">
                          You will join a hut of {room.maxUsersPerGroup} people.
                          Additional users will be placed in a new hut.
                        </div>
                      </div>
                    ) : undefined}
                    <div
                      className={`border-b dark:border-matteGray h-px ${
                        room.maxUsersPerGroup ? "mt-4" : ""
                      }`}
                    ></div>
                    {room.totalLiveCalls ? (
                      <div className="flex flex-row justify-start items-center mt-4 ">
                        <div
                          className="w-10 h-10 dark:text-frescoWhite border rounded-full flex justify-center items-center"
                          style={{ minWidth: 40 }}
                        >
                          <svg
                            width="20"
                            height="20"
                            aria-hidden="true"
                            focusable="false"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.0013 18.3337C14.6037 18.3337 18.3346 14.6027 18.3346 10.0003C18.3346 5.39795 14.6037 1.66699 10.0013 1.66699C5.39893 1.66699 1.66797 5.39795 1.66797 10.0003C1.66797 14.6027 5.39893 18.3337 10.0013 18.3337Z"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M10 5V10L13.3333 11.6667"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="font-normal text-sm text-darkGray ml-4">
                          After {room.totalLiveCalls} people you will be placed
                          in the queue.
                        </div>
                      </div>
                    ) : undefined}
                  </div>
                ) : (
                  <div className="flex flex-row justify-start items-center mt-4 ">
                    <div
                      className="w-10 h-10 dark:text-frescoWhite border rounded-full flex justify-center items-center"
                      style={{ minWidth: 40 }}
                    >
                      <svg
                        width="20"
                        height="20"
                        aria-hidden="true"
                        focusable="false"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.6654 17.5V15.8333C16.6654 14.9493 16.3142 14.1014 15.6891 13.4763C15.0639 12.8512 14.2161 12.5 13.332 12.5H6.66536C5.78131 12.5 4.93346 12.8512 4.30834 13.4763C3.68322 14.1014 3.33203 14.9493 3.33203 15.8333V17.5"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M10.0013 9.16667C11.8423 9.16667 13.3346 7.67428 13.3346 5.83333C13.3346 3.99238 11.8423 2.5 10.0013 2.5C8.16035 2.5 6.66797 3.99238 6.66797 5.83333C6.66797 7.67428 8.16035 9.16667 10.0013 9.16667Z"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="font-normal text-sm text-darkGray ml-4">
                      You will be matched in 1:1 calls.
                    </div>
                  </div>
                )}

                {room?.isRequireApproval ? (
                  <>
                    <div
                      className={`border-b dark:border-matteGray h-px ${
                        room.maxUsersPerGroup ? "mt-4" : ""
                      }`}
                    ></div>
                    <div className="flex flex-row justify-start items-center mt-4">
                      <div
                        className="w-10 h-10 dark:text-frescoWhite border rounded-full flex justify-center items-center"
                        style={{ minWidth: 40 }}
                      >
                        <Check ratio={20} />
                      </div>

                      <div className="font-normal text-sm text-darkGray ml-4">
                        Host approval required when joining the call.
                      </div>
                    </div>
                  </>
                ) : undefined}
              </div>
              {isFetchingTagsLocation && !tagsLocation && (
                <div className="pt-4 pb-4 pr-10 hidden md:block">
                  <ResourceSkeleton />
                </div>
              )}
              {tagsLocation && !isMobile() && (
                <div className="pt-4 pb-4 pr-10 hidden md:block">
                  <Resources
                    tagsLocation={tagsLocation}
                    roomId={roomId}
                    roomOwner={room?.owner?._id}
                  />
                </div>
              )}
            </div>
            <div className="w-full md:pt-0 pt-4 pb-4 md:pr-10 hidden md:block">
              <p className="text-base font-bold pt-4 pb-2 text-black dark:text-frescoWhite">
                Activity
              </p>
              <ActivityRoom
                roomId={roomId}
                isRoomBody={true}
                loadMoreButton={true}
              />
            </div>
          </div>
          <div className="md:w-1/2 w-full md:pt-0 pt-4 ">
            <div>
              <p className="text-base font-bold pb-2 text-black dark:text-frescoWhite">
                Currently Active
              </p>
              {calls.length !== 0 ? (
                <div className="">
                  <span className="dark:text-frescoWhite text-darkGray text-sm">
                    {talkingUsersCount} talking
                  </span>
                  <span
                    className="cursor-pointer text-sm dark:text-frescoWhite text-darkGray"
                    onClick={() => setIsModalOpen(true)}
                  >
                    &nbsp;·&nbsp;<span className="text-primary">See All</span>
                  </span>

                  {/* )} */}
                  <div className="flex flex-wrap w-full">
                    <div className="grid grid-cols-4 gap-4">
                      {users.slice(0, 12).map((user, index) => (
                        <div
                          key={index}
                          className="relative mt-5"
                          onMouseEnter={() => {
                            setShowUserTooltip(true);
                            setUsername(user.username);
                          }}
                          onMouseLeave={() => {
                            setShowUserTooltip(false);
                            setUsername("");
                          }}
                        >
                          <Avatar
                            containerStyle={{ width: "64px", marginRight: 10 }}
                            src={user.profile_picture}
                            username={user.username}
                            size="md"
                          />
                          {/* {this._renderSocialIcon(user.provider)} */}
                          {showUserTooltip && username === user.username && (
                            <>
                              {user.provider === "metamask" ? (
                                <PopOver
                                  text={user.username}
                                  leftPosition={"-left-12"}
                                  size="40"
                                />
                              ) : (
                                <PopOver
                                  text={user.username}
                                  leftPosition={"-left-4"}
                                />
                              )}
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <p className=" text-sm font-normal  text-darkGray">
                  This call is open for you to join and share with friends.
                  <br />
                  Attend upcoming events to join with others.
                </p>
              )}
            </div>

            {(room?.weeklyPassCharge || 0) > 0 && (
              <WeeklyPassCard
                roomId={roomId}
                amount={room.weeklyPassCharge}
                roomName={room.name}
                isModerator={isModerator()}
              />
            )}

            <div className="pt-4 pb-4">
              <div className="md:pr-10 flex flex-col space-y-4 max-w-md ">
                <div className={`flex justify-between items-center pt-4`}>
                  <div className="flex items-center space-x-2 dark:text-frescoWhite font-bold text-black">
                    <p>Events</p>
                  </div>
                  <div className="flex items-center gap-2 ">
                    {room?.owner?._id !== undefined &&
                      (user?._id === room?.owner?._id ||
                        (room?.moderators !== undefined &&
                          room?.moderators?.includes(user?._id))) && (
                        <Button
                          variant="vibhut-primary-outline"
                          onClick={() => setCreateEventOpen(true)}
                        >
                          Create Event
                        </Button>
                      )}
                    {room?.owner?._id !== undefined &&
                      (user?._id === room?.owner?._id ||
                        (room?.moderators !== undefined &&
                          room?.moderators?.includes(user?._id))) && (
                        <div className={`flex justify-end items-center`}>
                          <button
                            className="px-1 py-1 bg-gradient-btn-border text-white rounded-3xl"
                            onClick={() => {
                              setIsEventModalOpen(true);
                            }}
                          >
                            <div className="bg-gradient-btn flex align-center items-center  rounded-3xl justify-center px-1.5 sm:px-4 py-2">
                              <DoubleStar />
                              <p className="text-sm font-light ml-0.5">
                                Create with AI
                              </p>
                            </div>
                          </button>
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <>
                <div className="md:pr-10 pt-4 flex flex-col space-y-4 max-w-md">
                  {isFetching ? (
                    <EventCardSkeleton numberOfCards={3} />
                  ) : events.length !== 0 ? (
                    events?.map((event) => (
                      <EventCard
                        key={event._id}
                        event={event}
                        eventCallBack={eventCallBack}
                      />
                    ))
                  ) : (
                    <p className="text-sm font-normal  text-darkGray ">
                      There are no events at this time. Check back later.
                    </p>
                  )}
                </div>
                <div className="flex justify-center pt-4 gap-2 md:pr-10">
                  <div className="">
                    {isFetching ? undefined : !isMoreRoomEventsFetching ? (
                      isMoreRoomEvents && (
                        <Button
                          size="vibhut-sm"
                          variant="vibhut-secondary"
                          onClick={handleLoadMoreRoomEvents}
                        >
                          Load More
                        </Button>
                      )
                    ) : (
                      <div className="pt-2 md:flex justify-center">
                        <Loader />
                      </div>
                    )}
                  </div>

                  <Button
                    size="vibhut-sm"
                    variant="vibhut-secondary"
                    onClick={() => setIsAllEventModelOpen(true)}
                  >
                    See All Events
                  </Button>
                </div>
              </>
            </div>
            {room?.isSelfOrganized && (
              <div className="pt-4 pb-4" ref={sectionRef}>
                <SelfOrganizedEvents room={room} roomOwner={room?.owner?._id} />
              </div>
            )}

            {room?.isTestimonialEnabled && (
              <div className="pt-4 pb-4" ref={sectionRef}>
                <RoomTestimonials room={room} />
              </div>
            )}

            {tagsLocation && isMobile() && (
              <div className="pt-4 pb-4 invisible md:hidden">
                <Resources
                  tagsLocation={tagsLocation}
                  roomId={roomId}
                  roomOwner={room?.owner?._id}
                />
              </div>
            )}
            <div className="w-full md:pt-0 pt-4 pb-4 md:pr-10 md:hidden">
              <p className="text-base font-bold pt-4 pb-2 text-black dark:text-frescoWhite">
                Activity
              </p>
              <ActivityRoom
                roomId={roomId}
                isRoomBody={true}
                loadMoreButton={true}
              />
            </div>
          </div>
        </div>
      )}

      <TalkingUsersModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        usersCount={liveUsersCount}
        talkingUsers={calls}
        lobby_users={lobbyUsers}
      />
      <RoomModal
        isOpen={isOpenRoomPass}
        roomId={room._id}
        setIsOpen={setOpenRoomPass}
      />

      {isCreateEventOpen && (
        <CreateEvent
          isOpen={isCreateEventOpen}
          setIsOpen={setCreateEventOpen}
          roomId={room._id}
          eventData={eventData}
          roomCallMaxParticipants={room?.maxUsersPerGroup}
        />
      )}
      {isAllEventModelOpen && (
        <AllEventModel
          isOpen={isAllEventModelOpen}
          setIsOpen={setIsAllEventModelOpen}
          roomId={roomId}
          upcomingEvents={events}
        />
      )}
      <React.Fragment>
        {user?._id && (
          <>
            <QrCodeModal isOpen={isQRModalOpen} setIsOpen={setIsQRModalOpen} />
          </>
        )}
      </React.Fragment>
      {isEditOpen && (
        <EditRoom
          isOpen={isEditOpen}
          setIsOpen={setIsEditOpen}
          room={room}
          getRoom={getRoom}
        />
      )}
      <CreateEventByAIModal
        isOpen={isEventModalOpen}
        handleCreate={handleOpenCreateEventWithAI}
        setIsOpen={setIsEventModalOpen}
      />
      <EmbedRoomModal
        isOpen={isEmbedOpen}
        setIsOpen={setIsEmbedOpen}
        roomId={roomId}
      />
      {room.hasSubscription && (
        <SubscriptionModal
          isOpen={isSubscriptionOpen}
          setIsOpen={setIsSubscriptionOpen}
          amount={room?.subscriptionAmount}
          room={room}
          roomOwner={room.owner._id}
          subscriptionData={subscriptionData}
          setSubscriptionData={setSubscriptionData}
          roomName={room?.name}
        />
      )}

      {user?._id &&
        room.owner &&
        (room.owner._id === user?._id || room.owner === user?._id) && (
          <DeleteRoom
            isOpen={isDeleteOpen}
            setIsOpen={setIsDeleteOpen}
            room={room}
          />
        )}
    </div>
  );
}

export default SingleRoomPage;
